import { Component, Input } from '@angular/core';
import { SoftPopupComponent, TriggerSoftPopupDirective } from 'components/layout/soft-popup/soft-popup.component';
import { CompanyModel } from 'models/generated/Entities.GormCrm.Company';
import { Layout } from 'modules/layout';
import { ComponentUrl } from 'services/navigation.service';
import { ContactCardComponent } from './contact-card.component';
import { TooltipComponent } from 'components/shared/tooltip/tooltip.component';


@Component({
	selector: 'company-contact',
	templateUrl: './company-contact.component.html',
	styleUrls: ['./company-contact.component.scss'],
	imports: [Layout, TriggerSoftPopupDirective, SoftPopupComponent, ContactCardComponent, TooltipComponent]
})
@ComponentUrl('company-contact')
export class CompanyContactComponent {

	@Input() company!: CompanyModel;
}
